<template>
  <div class="content">
    <div class="header">
      <div
        v-for="(item,index) in labledata"
        :key="index"
        :class="{heightlight : lableindex==index}"
        @click="lableArea(index,item)"
      >
        {{item}}
        <div v-if="lableindex==index" class="xian"></div>
      </div>
    </div>
    <div v-if="list.length>0">
      <div>
        <div class="nav" v-for="(item,index) in list" :key="index" @click="newsVideo(item)">
          <div class="navfirst">{{item.name}}</div>
          <!-- <div class="navsecond">
            <div style="width:700px">
              <el-progress :percentage="percentage" :show-text="false" :stroke-width="22"></el-progress>
            </div>
            <div style="font-weight:700;margin-left:10px;font-size:16px">已学：{{percentage}}%</div>
          </div>-->
          <div class="navthirt">
            <div class="navthirt-box">
              <div>
                <span v-if="item.learnStatus==1" style="color: #409EFF;">学习中</span>
                <span v-else-if="item.learnStatus==2" style="color: #7DC23A;">已学完</span>
                <span v-else-if="item.learnStatus==0" style="color: #909399;">未学习</span>
              </div>
              <div></div>
              <div>{{item.score}} 分</div>
            </div>
            <span class="banji">班级：{{item.trainName}}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else style="margin-top: 120px;">
      <nodata></nodata>
    </div>

    <div class="pagination">
      <el-pagination
        background
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage2"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="100"
        layout="total,sizes, prev, pager, next"
        :total="dataCount"
        v-if="dataCount>0"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import * as ApiPerson from '@/api/personcenter/index';

export default {
  data() {
    return {
      dataCount: 0,
      percentage: 20,
      labledata: ['进行中的课程'],
      currentPage2: 1,
      lableindex: 0,
      timedata: '2020-06-23 12:03:45',
      learingarea: '上次学到：1.1 地方政府的界定',
      listQuery: {
        page: 1,
        limit: 8,
        userId: 1,
        status: 2,
      },
      list: [],
    };
  },
  created() {
    this.myLearnInfoList();
  },
  methods: {
    newsVideo(row) {
      if (row.objType == 2) {
        sessionStorage.setItem('trainId', row.trainId);
        this.$router.push({
          path: '/studyclassDetail',
          query: {
            id: row.objId,
            trainId: this.trainId,
          },
        });
      } else if (row.objType == 1) {
        sessionStorage.setItem('trainId', row.trainId);
        this.$router.push({
          path: '/sourceslist/videoLearn',
          query: {
            id: row.objId,
            trainId: this.trainId,
          },
        });
      }
    },
    myLearnInfoList() {
      ApiPerson.myLearnInfoList(this.listQuery).then((res) => {
        this.list = res.data;
        this.dataCount = res.count;
      });
    },
    lableArea(index, item) {
      this.lableindex = index;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>
<style scoped>
.content {
  width: 900px;
  height: 1000px;
}
hr {
  margin: 1px;
  border-top: 1px solid #e2e3e6;
}
.heightlight {
  color: #409eff !important;
}
.header {
  width: 850px;
  height: 35px;
  border-bottom: solid 1px #ccc;
  padding-top: 10px;
  display: flex;
}
.header > div {
  width: 150px;
  text-align: center;
  line-height: 35px;
  font-size: 16px;
  cursor: pointer;
}
.header > div:hover {
  color: #409eff;
}
.xian {
  width: 140px;
  border: solid 1px #409eff;
  margin-left: 8px;
}
.nav {
  width: 830px;
  height: 90px;
  /* background-color: blue; */
  margin: 0 auto;
  margin-top: 16px;
  border-radius: 10px;
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  cursor: pointer;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.nav:hover {
  box-shadow: 2px 2px 5px rgba(52, 194, 250, 0.969) !important;
}
.navfirst {
  font-weight: 700;
  font-size: 16px;
}
.navsecond {
  margin-top: 20px;
  display: flex;
}
.navsecond /deep/.el-progress-bar__inner {
  background: linear-gradient(
    to right,
    rgb(0, 168, 247),
    rgb(119, 227, 241)
  ) !important;
}
.navthirt {
  display: flex;
  justify-content: space-between;
  color: #7f7f7f;
  font-size: 16px;
  /* margin-top: 20px; */
}
.navthirt > div {
  margin-left: 10px;
}
.navthirt > div:nth-child(2) {
  border: 1px solid #7f7f7f;
}
.navthirt-box > div:nth-child(2) {
  border: 1px solid #7f7f7f;
  margin: 0 10px;
}
.navthirt-box {
  display: flex;
}
.banji {
  min-width: 140px;
}
.pagination {
  margin-top: 20px;
  text-align: center;
}
</style>